import { useState, useEffect } from 'react';
import Select from 'react-select';
import DropDownStyles from './dropdownStyles';
import { toDateInputValue } from '../../utils/toDateInputValue';

const DateWithUnknownSelector = ({ value, onChange, label, error }) => {
  const [dateType, setDateType] = useState(value?.dateType || null);
  const [dateValue, setDateValue] = useState(value?.dateValue || '');

  useEffect(() => {
    if (value) {
      setDateType(value.dateType || null);
      setDateValue(value.dateValue || '');
    }
  }, [value]);

  const dateTypeOptions = [
    { value: 'Unknown', label: 'Unknown' },
    { value: 'Date (mm/dd/yyyy)', label: 'Date (mm/dd/yyyy)' }
  ];

  const handleDateTypeChange = (selectedOption) => {
    const newDateType = selectedOption ? selectedOption.value : null;
    setDateType(newDateType);
    
    if (newDateType === 'Unknown') {
      setDateValue('');
      onChange({ dateType: 'Unknown', dateValue: null });
    } else {
      onChange({ dateType: newDateType, dateValue: dateValue || null });
    }
  };

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setDateValue(newDate);
    onChange({ dateType, dateValue: newDate || null });
  };

  // Format date for input (YYYY-MM-DD; calendar dates from API ISO strings must use UTC date, not local getters)
  const formatDateForInput = (date) => {
    if (!date) return '';
    if (typeof date === 'string') {
      if (date.includes('/') && !date.includes('T')) {
        const parts = date.split('/');
        if (parts.length === 3) {
          const month = parts[0].padStart(2, '0');
          const day = parts[1].padStart(2, '0');
          const year = parts[2];
          return `${year}-${month}-${day}`;
        }
      }
    }
    return toDateInputValue(date);
  };

  const inputDateValue = formatDateForInput(dateValue);

  return (
    <div>
      <div className="mb-3">
        <label className="form-label mb-2 fw-semibold">
          {label}
        </label>
        <Select
          value={dateTypeOptions.find(opt => opt.value === dateType)}
          onChange={handleDateTypeChange}
          options={dateTypeOptions}
          styles={DropDownStyles}
          placeholder={`Select ${label} Type`}
          isClearable={true}
        />
      </div>
      
      {dateType === 'Date (mm/dd/yyyy)' && (
        <div className="mb-0">
          <label className="form-label small mb-1">Date (mm/dd/yyyy)</label>
          <input
            type="date"
            className="form-control"
            value={inputDateValue}
            onChange={handleDateChange}
          />
        </div>
      )}
      {error && <div className="text-danger mt-2" style={{ fontSize: '0.85rem' }}>{error}</div>}
    </div>
  );
};

export default DateWithUnknownSelector;

